import { render, staticRenderFns } from "./introBasic.vue?vue&type=template&id=1801d2b0"
import script from "./introBasic.vue?vue&type=script&lang=js"
export * from "./introBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports